import React, { Component } from 'react'

export class Accordion extends Component {
  render() {
    return (
      <div>Accordion</div>
    )
  }
}

export default Accordion


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/Accordion.js